import BaseModel from '@/data/BaseModel';
import IntegrationMap from './map';

import { Map } from 'immutable';

export const STATUS_UNKNOWN = 0;
export const STATUS_ACTIVATED = 1;
export const STATUS_DEACTIVATED = 2;

export default class Integration extends BaseModel({
  // General integration data
  key: null,
  name: '',
  description: '',
  feature: null,

  // Information specific to this account
  accountId: null,
  kind: '',
  keyId: '',
  data: new Map(),
  status: STATUS_UNKNOWN,
  createdAt: null,
  updatedAt: null,
  deletedAt: null,

  actions: [],

  maps: new Map(),
}) {
  constructor(props = {}) {
    // This will convert the array of map objects into a dictionary that is keyed by the type of object being mapped.
    // Like user, position, etc... And then by the localId for that object. This will make it so there will not be any
    // conflicts and looking up maps for specific objects should be much easier.
    const maps = Map({}).withMutations(map => {
      (props.maps || []).map(item => {
        map.setIn([item.type, item.localId], new IntegrationMap(item));
      });
    });

    super({ ...props, maps: new Map(maps) });
  }

  isActivated() {
    return this.status === STATUS_ACTIVATED;
  }
}
